import React             from 'react';
import TextAreaComponent from './TextAreaComponent';

const SpecialInstruction = (props) => {
  const { parameters } = props
  const name = 'special_instructions';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const value = parameters.get ? parameters.get(name) : parameters[name];
  return (
    <TextAreaComponent
      label="Special Instructions"
      name={name}
      onChange={onChange}
      value={value || ''}
      groupName={props.groupName} />
  );
};

export default SpecialInstruction;
